import { render, staticRenderFns } from "./orderSend2.vue?vue&type=template&id=2b91b458&scoped=true"
import script from "./orderSend2.vue?vue&type=script&lang=js"
export * from "./orderSend2.vue?vue&type=script&lang=js"
import style0 from "./orderSend2.vue?vue&type=style&index=0&id=2b91b458&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b91b458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b91b458')) {
      api.createRecord('2b91b458', component.options)
    } else {
      api.reload('2b91b458', component.options)
    }
    module.hot.accept("./orderSend2.vue?vue&type=template&id=2b91b458&scoped=true", function () {
      api.rerender('2b91b458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/lists/orderSend2.vue"
export default component.exports